import { useState } from 'react';

import { PageHeader } from '@/components/common/page-header';
import { ListingsPanel } from '@/components/store/listings-panel';
import { ScreenshotsPanel } from '@/components/store/screenshots-panel';
import { PLATFORM_LABELS, PLATFORMS } from '@/components/store/store-constants';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import type { StorePlatform } from '@/types/store';

/**
 * Store-listing automation console. One tab per store; each shows that store's
 * listing copy and screenshot slots. Editing saves a draft; an explicit publish
 * pushes it live (through store review). Admin-only — the backend is
 * `Roles(ADMIN)` and the route is gated to match.
 */
export function StoreMetadataPage(): JSX.Element {
  const [platform, setPlatform] = useState<StorePlatform>('google_play');

  return (
    <div className="space-y-6">
      <PageHeader
        title="Store Metadata"
        description="Manage and publish Google Play & App Store listing copy and screenshots."
      />

      <Tabs value={platform} onValueChange={(value) => setPlatform(value as StorePlatform)}>
        <TabsList>
          {PLATFORMS.map((p) => (
            <TabsTrigger key={p} value={p}>
              {PLATFORM_LABELS[p]}
            </TabsTrigger>
          ))}
        </TabsList>

        {PLATFORMS.map((p) => (
          <TabsContent key={p} value={p} className="mt-4 space-y-6">
            <ListingsPanel platform={p} />
            <ScreenshotsPanel platform={p} />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
